import { Menu } from '@mantine/core'
import type { Reference, Resource } from '@medplum/fhirtypes'
import { generateMedplumAppLink } from '@seen/core/utilsExtendedResource'
import { IconExternalLink } from '@tabler/icons-react'

import type { JSX } from 'react'

interface MantineMenuItemMedplumLinkActionProps<
  T extends Resource | Reference,
> {
  resource: T
}

export function MantineMenuItemMedplumLinkAction<
  T extends Resource | Reference,
>({ resource }: MantineMenuItemMedplumLinkActionProps<T>): JSX.Element | null {
  return (
    <Menu.Item
      leftSection={<IconExternalLink className="size-4" />}
      onClick={() => window.open(generateMedplumAppLink(resource))}
    >
      View in Medplum
    </Menu.Item>
  )
}
